const blogHome = (editor) => {

    editor.BlockManager.add('blogHome', {
        category: `Built In Templates`,
        label: `Blog Home Template`,
        attributes: {},
        content: `
        <div>
            <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
                <div class="container">
                    <a class="navbar-brand" href="#!">Start Wabli</a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li class="nav-item nav-link pointer" href="#">Home</li>
                            <li class="nav-item nav-link pointer" href="#!">About</li>
                            <li class="nav-item nav-link pointer" href="#!">Contact</li>
                            <li class="nav-item nav-link active pointer" aria-current="page" href="#">Blog</li>
                        </ul>
                    </div>
                </div>
            </nav>
            <header class="py-5 bg-light border-bottom mb-4">
                <div class="container">
                    <div class="text-center my-5">
                        <h1 class="fw-bolder">Welcome to Blog Home!</h1>
                        <p class="lead mb-0">A Bootstrap 5 starter layout for your next blog homepage</p>
                    </div>
                </div>
            </header>
            <div class="container">
                <div class="row">
                    <div class="col-lg-8" dataItems="getAllCards">
                        <div dataitem=true class="card mb-4">
                            <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/850x350/dee2e6/6c757d.jpg" alt="..." /></a>
                            <div class="card-body">
                                <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                <h2 dataCardTitle=true class="card-title">Featured Post Title</h2>
                                <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla? Quos cum ex quis soluta, a laboriosam. Dicta expedita corporis animi vero voluptate voluptatibus possimus, veniam magni quis!</p>
                                <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div dataitem=true class="card mb-4">
                                    <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/700x350/dee2e6/6c757d.jpg" alt="..." /></a>
                                    <div class="card-body">
                                        <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                        <h2 dataCardTitle=true class="card-title h4">Post Title</h2>
                                        <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla.</p>
                                        <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                                    </div>
                                </div>
                                <div dataitem=true class="card mb-4">
                                    <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/700x350/dee2e6/6c757d.jpg" alt="..." /></a>
                                    <div class="card-body">
                                        <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                        <h2 dataCardTitle=true class="card-title h4">Post Title</h2>
                                        <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla.</p>
                                        <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div dataitem=true class="card mb-4">
                                    <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/700x350/dee2e6/6c757d.jpg" alt="..." /></a>
                                    <div class="card-body">
                                        <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                        <h2 dataCardTitle=true class="card-title h4">Post Title</h2>
                                        <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla.</p>
                                        <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                                    </div>
                                </div>
                                <div dataitem=true class="card mb-4">
                                    <a href="#!"><img dataCardImage=true class="card-img-top" src="https://dummyimage.com/700x350/dee2e6/6c757d.jpg" alt="..." /></a>
                                    <div class="card-body">
                                        <div dataCardDate=true class="small text-muted">January 1, 2021</div>
                                        <h2 dataCardTitle=true class="card-title h4">Post Title</h2>
                                        <p dataCardDescription=true class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla.</p>
                                        <a dataCardButton=true class="btn btn-primary" href="#!">Read more →</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <nav aria-label="Pagination">
                            <hr class="my-0" />
                            <ul pagination-list=true class="pagination justify-content-center my-4">
                                <li class="page-item" pagination-first=true><a class="page-link" href="#" tabindex="-1">First</a></li>
                                <li class="page-item active" aria-current="page"><a class="page-link" href="#!">1</a></li>
                                <li class="page-item"><a class="page-link" href="#!">2</a></li>
                                <li class="page-item"><a class="page-link" href="#!">3</a></li>
                                <li class="page-item disabled"><a class="page-link" href="#!">...</a></li>
                                <li class="page-item"><a class="page-link" href="#!">15</a></li>
                                <li class="page-item" pagination-last=true><a class="page-link" href="#!">Last</a></li>
                            </ul>
                        </nav>
                    </div>
                    <div class="col-lg-4">
                        <div class="card mb-4">
                            <div class="card-header">Search</div>
                            <div class="card-body">
                                <div class="input-group">
                                    <input class="form-control" type="text" placeholder="Enter search term..." aria-label="Enter search term..." aria-describedby="button-search" />
                                    <button class="btn btn-primary" id="button-search" type="button">Go!</button>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-4">
                            <div class="card-header">Categories</div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <ul class="list-unstyled mb-0">
                                            <li><a href="#!">Web Design</a></li>
                                            <li><a href="#!">HTML</a></li>
                                            <li><a href="#!">Freebies</a></li>
                                        </ul>
                                    </div>
                                    <div class="col-sm-6">
                                        <ul class="list-unstyled mb-0">
                                            <li><a href="#!">JavaScript</a></li>
                                            <li><a href="#!">CSS</a></li>
                                            <li><a href="#!">Tutorials</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-4">
                            <div class="card-header">Side Widget</div>
                            <div class="card-body">You can put anything you want inside of these side widgets. They are easy to use, and feature the Bootstrap 5 card component!</div>
                        </div>
                    </div>
                </div>
            </div>
            <footer class="py-5 bg-dark">
                <div class="container"><p class="m-0 text-center text-white">Copyright &copy; Your Website 2021</p></div>
            </footer>
        </div>
        `
    })
}

export default blogHome;